// @flow

import React, { type Node } from 'react';
import {
  getCountry,
  getSafeDueDate,
  usePendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';
import { Cell, Title, Value } from '../../../commons/voucher/ticket/ticket';
import { formatDueDate } from '@tectonics/prs/voucher';
import { getWeekDayByCountry } from '@tectonics/prs/week-day';

export function DisplayEfectyDueDate(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  const dueDate = getSafeDueDate(incomingPayment);

  return (
    <Cell>
      <Title>
        Fecha de Vencimiento
      </Title>

      <Value style={{ 'flex-direction': 'column' }}>
        {formatDueDate(dueDate)}
        <div style={{ fontSize: '14px' }}>
          (Paga hasta el {getWeekDayByCountry(dueDate, country)})
        </div>
      </Value>
    </Cell>
  );
}
